//import { fetchWithDefaults } from '../config/fetchDefault';

const decodeJsonFix= (json_str)=>{
    if(typeof json_str == 'undefined' || json_str == null){
        return {};
    }
    let jsonObj = null;
    try {
        jsonObj = JSON.parse(json_str);
    } catch (error) {
    }
    if (jsonObj === null){
        json_str = json_str.replace(/\\"/g, '"');
        jsonObj = JSON.parse(json_str);
    }
    return jsonObj;
}

export { decodeJsonFix };